import React from "react";
import { FaSignInAlt, FaUserPlus } from "react-icons/fa";
import { Link } from "react-router-dom";

const AuthAction = ({ to, icon: Icon, label, highlight = false }) => {
  return (
    <Link
      to={to}
      className={`
        group flex min-h-11 items-center gap-3 rounded-2xl border px-3 py-2
        text-sm font-bold shadow-lg backdrop-blur-xl transition duration-300
        hover:-translate-x-1 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange-400
        ${
          highlight
            ? "border-orange-400/40 bg-orange-500 text-white shadow-orange-500/20 hover:bg-orange-600"
            : "border-slate-200 bg-white/95 text-slate-800 shadow-slate-950/10 hover:border-orange-200 hover:text-orange-600 dark:border-white/10 dark:bg-slate-950/90 dark:text-white dark:hover:border-orange-400/40 dark:hover:text-orange-300"
        }
      `}
    >
      <span
        className={`
          flex h-8 w-8 shrink-0 items-center justify-center rounded-xl
          ${
            highlight
              ? "bg-white/15 text-white"
              : "bg-orange-50 text-orange-600 dark:bg-orange-500/15 dark:text-orange-300"
          }
        `}
      >
        <Icon className="h-4 w-4" />
      </span>

      <span className="hidden whitespace-nowrap sm:block">{label}</span>
    </Link>
  );
};

const AuthIcons = () => {
  return (
    <div className="fixed right-3 top-[150px] z-[60] sm:right-4 sm:top-[170px]">
      <div className="flex flex-col gap-2">
        <AuthAction to="/login" icon={FaSignInAlt} label="Se connecter" />

        <AuthAction
          to="/register"
          icon={FaUserPlus}
          label="S'inscrire"
          highlight
        />
      </div>
    </div>
  );
};

export default AuthIcons;